import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular/standalone';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor(private toastController: ToastController) {}

  async show(type: 'success' | 'danger' | 'info' | 'warning', message: string, position: 'top' | 'bottom' | 'middle' = 'middle') {
    let color = 'success';
    let icon;

    switch (type) {
      case 'info':
        color = 'info';
        icon = 'information-circle-outline';
        break;
      case 'success':
        color = 'success';
        icon = 'checkmark-circle-outline';
        break;
      case 'warning':
        color = 'warning';
        icon = 'warning-outline';
        break;
      case 'danger':
        color = 'danger';
        icon = 'alert-circle-outline';
        break;
    }

    const toast = await this.toastController.create({
      message,
      duration: 3000,
      position,
      mode: 'ios',
      color,
      icon,
      cssClass: ['toast', type]
    });

    await toast.present();
  }
}
